export const SCHEMA_VERSION = '1.8.0';
